module.exports = __webpack_public_path__ + "img/icon_zahnarzt_iso.7837a4bb.svg";